<script>
	import Vue from 'vue';

	export default {
		props: {
			position: {
				type: Number,
				default: 0
			},
			currentSlide: {
				type: Number,
				default: 0
			},
			totalSlides: {
				type: Number,
				default: 1
			},
			animation: {
				type: String
			},
			setFocus: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				isTransitioning: false
			};
		},
		computed: {
			isActive() {
				return this.position === this.currentSlide;
			},
			animated() {
				return ['slide', 'fade'].includes(this.animation);
			}
		},
		methods: {
			focusSlide() {
				if (this.setFocus && this.isActive) {
					Vue.nextTick(() => {
						const isFocused = document.activeElement === this.$el;
						if (!isFocused) {
							this.$el.focus();
						}
					});
				}
			},
			onTransitionEnd(event) {
				this.isTransitioning = false;

				this.focusSlide();
			}
		},
		watch: {
			isActive() {
				if (!this.animated) {
					this.focusSlide();
				} else {
					this.isTransitioning = true;
				}
			}
		}
	};
</script>
<style lang="scss">
	.carousel-slide {
		display: none;
		width: 100%;

		&.active {
			display: flex;
		}

		&.animated {
			display: flex;
			opacity: 0;
			position: absolute;
			left: 0;
			visibility: hidden;
			transition: opacity 0.8s ease-in-out;

			&.active {
				opacity: 1;
				visibility: visible;
			}

			&.transitioning {
				visibility: visible;
			}

			&.slide {
				left: 100%;
				transition:
					left 0.4s ease-in-out,
					opacity 0.4s ease-in-out;

				&.active {
					left: 0;
				}

				&.previous {
					left: -100%;
				}

				@media (prefers-reduced-motion) {
					transition: opacity 0.8s ease-in-out;

					&,
					&.previous {
						left: 0;
					}
				}
			}
		}
	}
</style>
<template>
	<div
		class="carousel-slide"
		:class="[
			{
				animated: animated,
				active: isActive,
				transitioning: isTransitioning,
				previous: animated && position < currentSlide
			},
			animation
		]"
		role="group"
		aria-roledescription="slide"
		:aria-label="position + 1 + ' of ' + totalSlides"
		:aria-hidden="`${!isActive}`"
		:tabindex="isActive ? 0 : -1"
		@transitionend.self="onTransitionEnd($event)">
		<slot></slot>
	</div>
</template>
